import { render, staticRenderFns } from "./questionarioIniziale.vue?vue&type=template&id=2f9a23b7&"
import script from "./questionarioIniziale.vue?vue&type=script&lang=ts&"
export * from "./questionarioIniziale.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports